// extracted by css-extract-rspack-plugin
export default {"address":"address-Znmh64"};